<template>
   <div id="container" class="map" tabindex="0"></div>
</template>

<script>
export default {
 data(){
     return{

     }
 },
 mounted(){
     this.initMap()
 },
 methods:{
   initMap(){
        var map = new AMap.Map('container');
        var path1 = [
            [75.757904, 38.118117],
            [97.375719, 24.598057],
            [117.375719, 38.118117]
        ];
       var polyline1 = new AMap.Polyline({
        path: path1,            // 设置线覆盖物路径
     	showDir:true,
        strokeColor: '#3366bb',   // 线颜色
        strokeWeight: 10           // 线宽
      });
      map.add([polyline1])
    
      map.setFitView()
   }
 },
  
}
</script>

<style>
 .map{
     width:100%;
     height: 100%;
 }

</style>